import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { useSite } from "../../context/SiteContext";

const label = (m) => (m.title ? m.title : `${m.home} - ${m.away}`);

export default function LiveAlert({ matches }) {
  const { trial } = useSite();
  const [alert, setAlert] = useState(null);
  const prev = useRef(null);
  const snap = useRef({ src: null, before: null });

  useEffect(() => {
    if (!matches.length) return undefined;
    if (snap.current.src !== matches) {
      snap.current = { src: matches, before: prev.current };
      prev.current = Object.fromEntries(matches.map((m) => [m.id, m.state]));
    }
    const before = snap.current.before;
    let pick = null;
    if (before) {
      pick = matches.find((m) => m.state === "in" && before[m.id] && before[m.id] !== "in");
    } else if (!sessionStorage.getItem("dl-live-alert")) {
      pick = matches.find((m) => m.state === "in");
    }
    if (!pick) return undefined;
    const t = setTimeout(() => { sessionStorage.setItem("dl-live-alert", "1"); setAlert(pick); }, before ? 0 : 6000);
    return () => clearTimeout(t);
  }, [matches]);

  useEffect(() => {
    if (!alert) return undefined;
    const t = setTimeout(() => setAlert(null), 14000);
    return () => clearTimeout(t);
  }, [alert]);

  return (
    <AnimatePresence>
      {alert && (
        <motion.div key={alert.id} data-testid="live-alert"
          initial={{ opacity: 0, y: 40, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 30 }}
          transition={{ type: "spring", stiffness: 260, damping: 24 }}
          className="fixed bottom-5 left-5 right-24 sm:right-auto sm:w-[360px] z-50 rounded-3xl border border-[#8a8dff]/40 bg-[#13114f]/90 backdrop-blur-xl p-5 shadow-[0_20px_60px_rgba(8,7,42,0.7)]">
          <button onClick={() => setAlert(null)} aria-label="Kapat" data-testid="live-alert-close"
            className="absolute right-3 top-3 p-1.5 text-[#c9c6f0] hover:text-white"><X size={16} /></button>
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-red-300">
            <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" /> Şimdi canlı · {alert.league}
          </p>
          <p className="mt-2 pr-6 font-display text-lg font-semibold leading-tight" data-testid="live-alert-match">{label(alert)}</p>
          <a href={trial} target="_blank" rel="noreferrer" data-testid="live-alert-trial-btn"
            className="group mt-4 inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#0d0b3d] hover:bg-[#5b5fd6] hover:text-white transition-colors">
            Ücretsiz test al <ArrowUpRight size={15} className="transition-transform group-hover:rotate-45" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
